<template>
  <HPopup class="h-create-room-popup"
          ref="popup"
          :closeOnClickModal="false"
          :border-index="6"
          :zIndex="zIndex"
          :visible.sync="visible">
    <div class="h-create-room-popup-container">
      <p class="popup-header">创建房间</p>
      <div class="create-form">
        <div class="form-item ">
          <div class="form-item-label">房间名称：</div>
          <div class="form-item-content h-outer-border around-4 bw2 bz0 h-bg blue-2">
            <input v-model="form.name"
                   ref="inputName"
                   autocomplete="off"
                   maxlength="10"
                   placeholder="输入房间名称（可不填）">
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">房间密码：</div>
          <div class="form-item-content h-outer-border around-4 bw2 bz0 h-bg blue-2">
            <input v-model="form.password"
                   type="text"
                   ref="inputPassword"
                   autocomplete="off"
                   maxlength="10"
                   :disabled="!userInfo.isPro"
                   :placeholder="userInfo.isPro ? '字母或数字（可不填）' : 'VIP用户专享'">
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">战场尺寸：</div>
          <div class="form-item-content flex">
            <div class="draft-mode-item" v-for="item in battleSizes" :key="item.id">
              <div v-click-sound-button
                   class="check-item inline-flex items-center"
                   :class="{ selected: form.battleMapType === item.val }"
                   @click="selectBattleSize(item)">
                <div class="check-box h-outer-border around-4 bw2 bz0 h-bg blue-2">
                  <img v-if="form.battleMapType === item.val" :src="`${$rHost}/img/btn/TPTHCHKG.png`"
                       alt="selected">
                </div>
                <div class="check-label">{{ item.name }}</div>
<!--                <HTag v-if="item.id === 1" title="VIP用户专享">VIP</HTag>-->
              </div>
            </div>
          </div>
        </div>
        <div class="form-item" style="height: 90px;">
          <div class="form-item-label">竞技模式：</div>
          <div class="form-item-content">
            <div class="draft-mode-item" v-for="item in draftModes" :key="item.id">
              <div v-click-sound-button
                   class="check-item inline-flex items-center"
                   :class="{ selected: form.draftModeId === item.id }"
                   @click="selectDraftMode(item)">
                <div class="check-box h-outer-border around-4 bw2 bz0 h-bg blue-2">
                  <img v-if="form.draftModeId === item.id" :src="`${$rHost}/img/btn/TPTHCHKG.png`"
                       alt="selected">
                </div>
                <div class="check-label">{{ item.name }}</div>
                <!--<HTag v-if="item.id === 2" title="VIP用户专享">VIP</HTag>-->
              </div>
            </div>
          </div>
        </div>
        <div class="form-item" style="height: 50px;">
          <div class="form-item-label">悬赏金：</div>
          <div class="form-item-content">
            <div class="draft-mode-item">
              <div class="flex justify-between">
                <div v-click-sound-button
                     class="check-item inline-flex items-center"
                     @click="selectBounty">
                  <div class="check-box h-outer-border around-4 bw2 bz0 h-bg blue-2">
                    <img v-if="form.isSetBounty" :src="`${$rHost}/img/btn/TPTHCHKG.png`"
                         alt="selected">
                  </div>
                  <div class="check-label">
                    设置PVP悬赏金
                  </div>
                </div>

                <div v-click-sound-button
                     class="h-title nowrap"
                     data-title="点击查看说明"
                     @click="onShowPvpBountyHelp">ℹ
                </div>
              </div>

            </div>

            <div v-show="form.isSetBounty"
                 class="h-outer-border around-4 bw2 bz0 h-bg blue-2 h-title nowrap"
                 data-title="输入100的整数倍">
              <input class=""
                     v-model="form.pvpBounty"
                     ref="inputName"
                     autocomplete="off"
                     maxlength="7"
                     placeholder="输入悬赏金（1000 ~ 100000）">
            </div>

          </div>
        </div>
        <div class="form-item buttons">
          <button v-click-sound-button class="h-button MUBCHCKN" @click="submit"></button>
          <button v-click-sound-button class="h-button MUBCANCN" @click="closePopup"></button>
        </div>
      </div>
    </div>
  </HPopup>

</template>

<script type="text/babel">
  import { mapActions, mapGetters } from 'vuex'
  import HPopup from '@/components/h-popup'
  import HTag from '@/components/base/h-tag'

  export default {
    data () {
      return {
        form: {
          name: '',
          password: '',
          draftModeId: 0,
          battleMapType: 'NORMAL',
          isSetBounty: false,
          pvpBounty: '',
        },
        draftModes: [
          {
            id: 0,
            name: '标准竞技',
          },
          {
            id: 1,
            name: '角色竞技',
          },
          {
            id: 2,
            name: '自由竞技',
          },
        ],
        battleSizes: [
          {
            id: 0,
            val: 'NORMAL',
            name: '标准',
          },
          {
            id: 1,
            val: 'LARGE',
            name: '大型',
          },
        ]
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: false
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    watch: {
      visible (val) {
        if (val) {
          this.initAnimationSpeed()
          /*this.$nextTick(() => {
            this.$refs.inputName.focus()
          })*/
        } else {
          this.form.isSetBounty = false
          this.form.pvpBounty = ''
        }
      }
    },

    computed: {
      ...mapGetters('user', [
        'userInfo',
      ]),
      ...mapGetters('gameData', [
        'animationSpeed',
      ]),
      ...mapGetters('hero', [
        'actionPoint',
      ]),
    },

    async mounted () {
    },

    methods: {
      ...mapActions('gameData', [
        'initAnimationSpeed',
      ]),

      closePopup () {
        this.$emit('update:visible', false)
      },

      selectDraftMode (item) {
        this.form.draftModeId = item.id
      },

      selectBattleSize (item) {
        this.form.battleMapType = item.val
      },

      focusInputPassword () {
        this.$refs.inputPassword.focus()
      },

      reset () {
        this.form.name = ''
        this.form.password = ''
      },

      selectBounty () {
        this.form.isSetBounty = !this.form.isSetBounty
        if (!this.form.isSetBounty) {
          this.form.pvpBounty = ''
        }
      },

      async submit () {
        if (!this.form.name.trim()) {
          this.form.name = `房间${String(Math.random()).slice(-6)}`
        }

        if (!this.form.name.trim()) {
          this.$emit('alert', '房间名称无效')
          return
        }

        if (this.form.name.length > 10) {
          this.$emit('alert', '房间名称最多10个字符')
          return
        }

        if (this.form.password && !/^[\w\d]{1,10}$/.test(this.form.password)) {
          this.$emit('alert', '密码为1-10位字母数字')
          return
        }

        if (this.form.password && !this.userInfo.isPro) {
          this.$emit('alert', '操作失败，VIP专业版用户专享')
          return
        }

        if (this.form.isSetBounty) {
          if (!this.form.pvpBounty || !(this.form.pvpBounty || '').trim()) {
            this.$emit('alert', '未输入悬赏金')
            return
          }
          if (!/^\d+$/.test(this.form.pvpBounty)) {
            this.$emit('alert', '悬赏金错误')
            return
          }
          if (this.form.pvpBounty % 100) {
            this.$emit('alert', '悬赏金为 100 的整数倍')
            return
          }
          if (this.form.pvpBounty < 1000) {
            this.$emit('alert', '悬赏金最低1000')
            return
          }
          if (this.form.pvpBounty > 100000) {
            this.$emit('alert', '悬赏金最高100000')
            return
          }
        }

        if (this.actionPoint <= 0) {
          this.$emit('alert', '行动力不足')
          return
        }

        if (this.form.battleMapType === 'LARGE' && this.form.draftModeId === 2) {
          this.$emit('alert', '“自由竞技”暂不支持大型战场尺寸')
          return
        }

        if (this.form.battleMapType === 'LARGE' && this.form.pvpBounty) {
          this.$emit('alert', '大型战场尺寸不支持悬赏金')
          return
        }

        this.$emit('submit', Object.assign({}, this.form, {
          isSetBounty: +this.form.isSetBounty || 0,
          pvpBounty: +this.form.pvpBounty || null,
          animationSpeed: +this.animationSpeed || 1,
        }))
        this.closePopup()
        this.reset()
      },

      onShowPvpBountyHelp () {
        this.$message('由房主设置PVP对战悬赏金。\n战斗开始：双方扣除金币，暂存至奖金池。\n战斗结束：胜利方赢得奖金池的所有金币。')
      },

    },

    components: {
      HPopup,
      HTag,
    }
  }
</script>

<style lang="stylus" scoped>
  .draft-mode-item
    width 100%

  .check-item
    position relative
    padding 3px 0
    cursor pointer
    vertical-align middle
    &:not(:last-child)
      margin-right 20px
    .check-box
      display flex
      justify-content center
      align-items center
      width 20px
      height 20px
      padding 3px
      img
        max-width 100%
    .check-label
      padding-left 5px
      line-height 20px
      font-size 12px
      letter-spacing 1px
      goldText1()
    .h-tag
      margin-left 5px

  .h-create-room-popup
    .h-create-room-popup-container
      width 280px
      user-select none

  .create-form
    margin-top 30px
    text-shadow 2px 2px 1px #000
    .form-item
      position relative
      display flex
      margin-bottom 20px
      height 30px
      line-height 30px
      .form-item-label
        padding-left 10px
        width 80px
        font-size 12px
        letter-spacing 1px
        color #fff
      .form-item-content
        position relative
        flex-shrink 0
        width calc(100% - 80px)
        margin-left 1px
        input
          position relative
          width 100%
          height 30px
          padding-left 10px
          line-height 30px
          border 0
          outline 0
          font-size 12px
          color #fff
          background-color transparent
          caret-color #f8e490
        input:-webkit-autofill
          background-image imgURL("/img/bg/bg_brown_2.jpg") !important
          background-color transparent !important
          box-shadow 0 0 0 1000px #fff inset
        input[type="number"]
          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button
            -webkit-appearance none !important
            margin 0
        input::-webkit-input-placeholder
          font-size 12px
          color #999

  .form-item.buttons
    display flex
    justify-content space-evenly
    margin-top 30px
    button
      width 96px
      height 48px

</style>
